import * as React from 'react';
import { CONFIG } from '../appconfig';
const XemDuLieuPage = React.lazy(() => import('../pages/XemDuLieuPage'));
import { APPLICATION } from '../constants/core.constant';
const QuanLyHaTangKyThuatGISPage = React.lazy(() => import('../pages/QuanLyHaTangKyThuatGISPage'));
const QuanLyHaTangThuongMaiPage = React.lazy(() => import('../pages/QuanLyHaTangThuongMaiGISPage'));
const QuanLyThongTinQuyHoachPage = React.lazy(() => import('../pages/QuanLyThongTinQuyHoach'));
const QuyHoachPage = React.lazy(() => import('../pages/ThongTinQuyHoachPage'));
const QuanLyLuuTruQuyHoachPage = React.lazy(() => import('../pages/QuanLyLuuTruQuyHoachPage'));
const QLSCPage = React.lazy(() => import('../pages/QLSCPage'));
const TNSCPage = React.lazy(() => import('../pages/TNSCPage'));

export interface Route {
  id: string; name: string; component?: any;
  props?: { math?: boolean, exact?: boolean, path: string };
  avatar?: string;
  isPrivate?: boolean;
  externalLink?: string;
  order?: number;
  /**
   * default = false
   */
  isEnabled?: boolean
}

const routes: Array<Route> = [
  {
    id: APPLICATION.QuanLyThongTinQuyHoach, name: 'Quản lý thông tin quy hoạch', component: QuanLyThongTinQuyHoachPage,
    props: { exact: true, path: '/quan-ly-thong-tin-quy-hoach' },
    avatar: '/images/icons/ttqh.png',
    isPrivate: true, order: 1
  },
  {
    id: APPLICATION.ThongTinQuyHoach, name: 'Thông tin quy hoạch', component: QuyHoachPage,
    props: { exact: true, path: '/thong-tin-quy-hoach' },
    avatar: '/images/icons/ttqh.png',
    isPrivate: false, order: 1
  },
  {
    id: APPLICATION.LuuTruQuyHoach, name: 'Lưu trữ quy hoạch', component: QuanLyLuuTruQuyHoachPage,
    props: { exact: true, path: '/luu-tru-quy-hoach' },
    avatar: '/images/icons/luutruquyhoach.png',
    isPrivate: true, order: 99
  },
  {
    id: APPLICATION.XemDuLieu, name: 'Tra cứu dữ liệu hạ tầng kỹ thuật', component: XemDuLieuPage,
    props: { exact: true, path: '/tra-cuu-du-lieu' },
    avatar: '/images/icons/qlhtkt.png', isPrivate: false
  },

  {
    id: APPLICATION.QuanLyHaTangKyThuatGIS, name: 'Quản lý hạ tầng kỹ thuật', component: QuanLyHaTangKyThuatGISPage,
    props: { path: '/quan-ly-ha-tang-ky-thuat-gis' },
    avatar: '/images/icons/qlhtkt.png', isPrivate: true, order: 2
  },
  {
    id: APPLICATION.QuanLyhHaTangThuongMai, name: 'Quản lý hạ tầng thương mai', component: QuanLyHaTangThuongMaiPage,
    props: { path: '/quan-ly-ha-tang-thuong-mai' },
    avatar: '/images/icons/qlhtkt.png', isPrivate: true, order: 2
  },
  {
    id: APPLICATION.QuanLySuCo, name: 'Quản lý sự cố HTKT', component: QLSCPage,
    props: { path: '/qlsc' },
    avatar: '/images/icons/qlsc.png', isPrivate: true, order: 3
  },
  {
    id: APPLICATION.QuanLySuCoDonVi, name: 'Quản lý Sự cố HTKT', component: QLSCPage,
    props: { path: '/qlsc-dv' },
    avatar: '/images/icons/qlsc.png', isPrivate: true
  },
  {
    id: APPLICATION.TiepNhanSuCo, name: 'Tiếp nhận sự cố', component: TNSCPage,
    props: { path: '/tnsc' },
    avatar: '/images/icons/tnsc.png', isPrivate: true, order: 4
  }
];

export default routes;
